import React, { useState } from "react";
import "./AddWallet.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { TextField, Button } from "@mui/material";
import AddWalletProceed from "./AddWalletProceed";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";

export default function AddWallet() {
  const { RendomTokenfetch, webSetting, walletbalance } = useAuth();

  const [amount, setAmount] = useState("");
  const [ShowWalletProceed, setShowWalletProceed] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);

  const amountLimit = webSetting.wallet_recharge_limit;
  const numericLimit = Number(amountLimit);

  const popularRecharges = [
    { amount: 50, extra: 50 },
    { amount: 100, extra: 100 },
    { amount: 200, extra: 100 },
    { amount: 1000, extra: 500 },
  ];

  const handleAmountClick = (recharge) => {
    setAmount(recharge.amount.toString());
    setSelectedOption(recharge.amount);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    // Check if input is empty or a valid number, and has <= 5 digits
    if (value === "" || (/^\d+$/.test(value) && value.length <= 4)) {
      setAmount(value);
      setSelectedOption(null);
    } else {
      NotifyMessageNoReload("Maximum 4 digits allowed!", "danger", true);
    }
  };

  const handleWalletProceedBack = () => {
    setShowWalletProceed(true);
  };

  const handleProceed = () => {
    if (!amount) {
      NotifyMessageNoReload("Please enter an amount", "danger", true);
      return;
    }
    const numericAmount = Number(amount);
    // Convert amountLimit to number (it's currently a string)

    if (numericAmount > numericLimit) {
      NotifyMessageNoReload(
        `Amount exceeds maximum limit! Only Limit  ${numericLimit}₹ `,
        "danger",
        true
      );

      return;
    } else {
      setShowWalletProceed(false);
    }

    // Add your payment processing logic here
    // console.log("Proceeding with amount:", amount);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Add Wallet" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            {ShowWalletProceed ? (
              <>
                <div className="wallet-add-container">
                  <div className="wallet-add-card">
                    <div className="Addwalletheadingbox">
                      <div className="balance-display">
                        <p className="balance-label">Available Balance</p>
                        <p className="balance-value">
                          ₹{walletbalance ? walletbalance : "0"}
                        </p>
                      </div>
                    </div>
                    <div className="amount-input-container">
                      <TextField
                        fullWidth
                        label="Enter Amount (₹)"
                        variant="outlined"
                        value={amount}
                        onChange={handleInputChange}
                        placeholder="Enter amount (Max 4  digits)"
                        type="number"
                        inputProps={{
                          maxLength: 4, // Limits input to 5 characters
                        }}
                        InputProps={{
                          startAdornment: "₹",
                        }}
                        className="amount-input-field"
                      />
                    </div>

                    <div className="popular-recharges-section">
                      <h3 className="recharge-title">Popular Add Money</h3>
                      <div className="recharge-grid">
                        {popularRecharges.map((recharge) => (
                          <div
                            key={recharge.amount}
                            className={`recharge-card ${
                              selectedOption === recharge.amount
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => handleAmountClick(recharge)}
                          >
                            <div className="recharge-amount">
                              ₹{recharge.amount}
                            </div>
                            {/* {recharge.extra && (
                          <div className="recharge-bonus">
                            + ₹{recharge.extra} Extra
                          </div>
                        )} */}
                          </div>
                        ))}
                      </div>
                    </div>

                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className="proceed-button"
                      onClick={handleProceed}
                      size="large"
                    >
                      Proceed to Pay
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <AddWalletProceed
                amount={amount}
                handleWalletProceedBack={handleWalletProceedBack}
              />
            )}
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
